// Qualquer tela pode pedir a conversa por voz (ex.: o passo da cartela). O chrome
// ouve este evento e abre a conversa ao vivo; sem ela liberada, abre o pedido
// rápido já ouvindo.
export const LIVE_OPEN_EVENT = 'secretario:live-open';

export function openLive(): void {
  window.dispatchEvent(new Event(LIVE_OPEN_EVENT));
}
